module.exports = __webpack_public_path__ + "img/logo.d17454d8.svg";